export const shape = {
  borderRadius: 4, // 1 * 8px (MUI default spacing) = 8px
}

/**
 * The corner radius of a CARD-LEVEL surface — the shared `Card`, `InfoBlock`, a product
 * image, a description accordion, the "Set default tag" prompt. One value, because these
 * sit directly beside each other on a detail page and a 4px difference between two
 * adjacent panels reads as a mistake rather than a distinction.
 *
 * WHY A TOKEN AND NOT A LITERAL. Every outlier this replaced carried a comment claiming
 * it already matched its neighbours — "Match the Description/Details accordion cards
 * below", "Parity with the Description/Details accordion" — while sitting at 8px next to
 * a 12px InfoBlock. The accordion those comments pointed at was itself the outlier, so
 * each new card copied the wrong value and recorded the right intent. That is the exact
 * failure `fieldChrome.ts` (FIELD_RADIUS) and `navChrome.ts` were extracted for: a
 * comment cannot enforce parity, only a shared symbol can.
 *
 * NESTED elements deliberately stay smaller (thumbnails, chips, menu rows). Concentric
 * radii should decrease inward — an inner box at the outer radius reads as misaligned.
 * This token is for the OUTER container only.
 */
export const SURFACE_RADIUS = 12